<section class="dashboard" aria-labelledby="dashboard-title">
  <nav class="dashboard-breadcrumb" aria-label="Ruta de navegación">
    <a routerLink="/dashboard">Inicio</a><span aria-hidden="true">›</span>
    <span aria-current="page">Sistema de Registro de Pagos por Servicios Ambientales (SR-PSA)</span>
    @if (identity()?.userType !== 'institutional') { <a routerLink="/registro-inicial">Mi perfil</a> }
    @if (identity()?.permissions?.includes('administrar_sistema')) { <a routerLink="/administracion">Administración</a> }
    <button type="button" class="dashboard-logout" (click)="logout()">Cerrar sesión</button>
  </nav>

  <div class="dashboard-body">
    <h1 id="dashboard-title">Sistema de Registro de Pagos por Servicios Ambientales (SR-PSA)</h1>
    <p class="dashboard-description">Los Proyectos de Pagos por Servicios Ambientales PSA, fue creado por el Decreto 1076 de 2015...</p>

    <section aria-labelledby="dashboard-actions-title">
      <h2 id="dashboard-actions-title">Acciones de la solicitud</h2>
      <div class="dashboard-actions">
        @if (canConsult()) {
          <a class="action-card" routerLink="/instrumento/proyectos" data-testid="consult-project">
            <h3>Consultar Proyecto</h3>
            <p>Consulte el estado de sus proyectos autorizados.</p>
          </a>
        }
        @if (canCreate()) {
          <a class="action-card" routerLink="/instrumento/registro" data-testid="create-project">
            <h3>Crear Proyecto</h3>
            <p>Registre un nuevo proyecto de PSA.</p>
          </a>
        }
      </div>
      @if (!hasActions()) {
        <p class="dashboard-empty" role="status">No tiene acciones de proyecto disponibles. Solicite al administrador que revise los permisos de su perfil.</p>
      }
    </section>
  </div>
</section>
